@if (mode === 'team') {
  <span class="font-semibold" data-hj-suppress>{{ schedule.employeeName }}</span>
}
<div class="flex gap-2">
  @if (shift?.long_name) {
    <span class="font-semibold">{{ shift?.long_name }}</span>
  } @else {
    <span class="font-semibold">{{ 'External' | translate }}</span>
  }
  <span
    >{{ schedule.starttime | time }}
    @if (!schedule.hide_end_time) {
      - {{ schedule.endtime | time }}
    }
  </span>
</div>
@if (isDisabled && !!scheduledDepartment?.name && !!scheduledTeam?.name) {
  <span class="font-semibold">{{ scheduledDepartment.name }} | {{ scheduledTeam.name }}</span>
}
@if (schedule.description) {
  <div class="flex items-start gap-2">
    <sb-icon class="shrink-0" [name]="'notepad'" />
    <span>{{ schedule.description }}</span>
  </div>
}
<!-- TODO Currently the conflict 'message' doesn't really provide any useful context. These should be structured like employability is. As long as these messages don't hint at the absence, schedule or availability details, we might as well only display one per category.-->
@if (conflicts) {
  <div class="flex flex-col gap-1">
    @for (conflict of conflicts[ConflictTopic.SKILL]; track $index) {
      <div class="flex items-center gap-2">
        <sb-icon [name]="'puzzle-piece'" class="text-danger" />
        <span>{{ conflict.message }}</span>
      </div>
    }
    @if (conflicts[ConflictTopic.TIME_OFF]) {
      <div class="flex items-center gap-2">
        <sb-icon [name]="'plane-departure'" class="text-danger" />
        <span>{{ conflicts[ConflictTopic.TIME_OFF][0].message }}</span>
      </div>
    }
    @if (conflicts[ConflictTopic.SCHEDULE]) {
      <div class="flex items-center gap-2">
        <sb-icon [name]="'calendar'" class="text-danger" />
        <span>{{ conflicts[ConflictTopic.SCHEDULE][0].message }}</span>
      </div>
    }
    @if (conflicts[ConflictTopic.AVAILABILITY]) {
      <div class="flex items-center gap-2">
        <sb-icon [name]="'user-times'" class="text-danger" />
        <span>{{ conflicts[ConflictTopic.AVAILABILITY][0].message }}</span>
      </div>
    }
  </div>
}
@if (violation?.messages?.length) {
  <div class="flex flex-col gap-1">
    <span class="font-semibold">{{ 'Violations' | translate }}:</span>
    <ul>
      @for (message of violation?.messages; track $index) {
        <li>{{ message }}</li>
      }
    </ul>
  </div>
}
